import { gateway } from "../../../../../gateway";
import { IWorkforce } from "../../interfaces/IWorkforce";

const getAuthHeader = () => {
  const token = sessionStorage.getItem("token");
  return { Authorization: token ?? "" };
};

export const updateWorkforce = async (uid: string, dto: Partial<IWorkforce>, params?: Record<string, any>) => {
  const rawPayload: any = {
    uid,
    workforceUid: uid,
    ...dto,
  };

  const payload: any = {};
  Object.keys(rawPayload).forEach((key) => {
    if (rawPayload[key] !== null && rawPayload[key] !== undefined) {
      payload[key] = rawPayload[key];
    }
  });

  const headers = getAuthHeader();

  try {
    const response = await gateway.patch(`/workforce`, payload, { headers, params });
    return response.data?.data || response.data;
  } catch (error) {
    console.error("Error updating workforce:", error);
    throw error;
  }
};
